export default "__VITE_ASSET__B4NWUC74__"